import { render, staticRenderFns } from "./ChangeTimeDurationDropdown.vue?vue&type=template&id=8644309c&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8644309c')) {
      api.createRecord('8644309c', component.options)
    } else {
      api.rerender('8644309c', component.options)
    }
    module.hot.accept("./ChangeTimeDurationDropdown.vue?vue&type=template&id=8644309c&functional=true", function () {
      api.rerender('8644309c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeTimeDurationDropdown.vue"
export default component.exports